import { Icon, Tooltip } from '@chakra-ui/react';
import { QuestionIcon } from '@chakra-ui/icons';
import React from 'react';

type Props = {
  label?: string;
};

export const ApmPaymentTooltip = ({ label }: Props) => {
  if (!label) {
    return null;
  }

  return (
    <Tooltip
      label={label}
      placement="top"
      borderRadius={0.5}
      backdropFilter="auto"
      backdropBlur={1}
      color="secondary.500"
      bg="primary.350"
      padding={1}
    >
      <Icon as={QuestionIcon} w="20px" h="20px" />
    </Tooltip>
  );
};
